import { render, staticRenderFns } from "./AccessGroupWindow.vue?vue&type=template&id=7448b0cb&"
import script from "./AccessGroupWindow.vue?vue&type=script&lang=js&"
export * from "./AccessGroupWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports